module.exports = __webpack_public_path__ + "img/top-arrow-2.4d7b7233.svg";